import { render, staticRenderFns } from "./CommentTable.vue?vue&type=template&id=d9c629a6&"
import script from "./CommentTable.vue?vue&type=script&lang=js&"
export * from "./CommentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports